import React, { useState, useEffect } from 'react';
import { Container, TextField, Typography, Paper, Grid, InputAdornment, IconButton, Modal, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Button } from '@mui/material';
import { FormControlLabel, Radio, RadioGroup, FormControl, Box, FormLabel, MenuItem, Select, InputLabel, FormHelperText } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';

import SearchIcon from '@mui/icons-material/Search';
import LoadingBar from 'react-top-loading-bar';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// ─────────────────────────────────────────────
// Info data for the dialog
// ─────────────────────────────────────────────
const registrationInfoSections = [
  {
    title: "Registration Details",
    color: "#1976D2",
    description: "Basic registration info including registration number, enquiry linkage, and registration date.",
    fields: ["Reg No. (Auto-generated)", "Enquiry No. (Search & Select)", "Date", "Without Enquiry (Yes / No)"],
  },
  {
    title: "Class Details",
    color: "#7B1FA2",
    description: "Details about the class the student is being registered for, along with their date of birth.",
    fields: ["Class *", "Date of Birth (DOB) *"],
  },
  {
    title: "Personal Details",
    color: "#388E3C",
    description: "Student's personal and contact information required for completing registration.",
    fields: [
      "Student Name *",
      "Father's Name *",
      "Mother's Name",
      "Grand Father's Name",
      "Prospectus",
      "Aadhar No.",
      "Gender *",
      "Nationality",
      "Mobile No. *",
      "Alternate Mobile No.",
      "Email-Id",
      "Address",
      "Pin Code",
      "Country *",
      "State *",
      "City *",
    ],
  },
  {
    title: "Mandatory Fields",
    color: "#C62828",
    description: "The following fields must be filled before saving the registration.",
    fields: ["Student Name", "Date of Birth", "Contact No.", "Father's Name"],
  },
  {
    title: "Actions",
    color: "#F57C00",
    description: "Available actions on the registration form.",
    fields: ["SAVE – Validates and submits the registration", "RESET – Clears all fields"],
  },
];

function AddRegistration() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  // ── Info dialog state ──
  const [infoOpen, setInfoOpen] = useState(false);
  //nabil
  let navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [showMissingFieldsModal, setShowMissingFieldsModal] = useState(false);
  const [registrationDate, setRegistrationDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
  }); //nabil
  const [enquiryData, setEnquiryData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedEnquiryId, setSelectedEnquiryId] = useState(0); // To store the selected enquiryId
  const [selectedEnquiryDetails, setSelectedEnquiryDetails] = useState({});
  // To store the details of the selected enquiry
  const [gender, setGender] = useState([]);
  const [ddlClass, setDdlClass] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [mandatoryFieldsError, setMandatoryFieldsError] = useState(false);
  const [registrationData, setRegistrationData] = useState({
    studentName: "",
    dob: "",
    contactNo: "",
    parentAndGurdian: "", // Use parentAndGurdian instead of fatherName
    emailId: "",
  });

  useEffect(() => {
    fetchGender();
    fetchddlClass();
    fetchCountry();
  }, []);

  const validateForm = () => {
    const mandatoryFields = [
      { name: 'Student Name', value: registrationData.studentName },
      { name: 'Date of Birth', value: registrationData.dob },
      { name: 'Contact No.', value: registrationData.contactNo },
      { name: 'Father\'s Name', value: registrationData.parentAndGurdian },
    ];

    const missing = mandatoryFields.filter(field => !field.value);
    setMissingFields(missing.map(field => field.name));
    return missing.length === 0;
  };

  // Fetch gender data
  const fetchGender = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Admission/ddlGender`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching gender: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setGender(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch class data
  const fetchddlClass = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setDdlClass(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch country data
  const fetchCountry = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlCountry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching country: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setCountry(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch state data
  const fetchState = async (countryId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlState`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          countryId: countryId,
        }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching state: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setState(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch city data
  const fetchCity = async (stateId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlCity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          stateId: stateId,
        }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching city: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setCity(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Handle search button click
  const handleSearchClick = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Registration/SearchEnqlist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching enquiry list: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setEnquiryData(data);
      setRegistrationData(data);
      setOpenModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelect = async (enquiryId) => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const apiUrl = `${url}/Registration/FetchEnquiryById`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ enquiryId }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching enquiry details: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }

      // Update selectedEnquiryDetails and registrationData with the correct fields
      const enquiryDetails = data[0];
      setSelectedEnquiryDetails(enquiryDetails);
      setRegistrationData({
        ...registrationData,
        studentName: enquiryDetails.studentName || "",
        dob: enquiryDetails.dob || "",
        contactNo: enquiryDetails.contactNo || "",
        parentAndGurdian: enquiryDetails.parentAndGurdian || "", // Use parentAndGurdian
        emailId: enquiryDetails.emailId || "",
      });
      setOpenModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  // Handle close modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Reset Function
  const handleReset = () => {
    setRegistrationData({
      studentName: "",
      dob: "",
      contactNo: "",
      parentAndGurdian: "",
      emailId: "",
    });
    setSelectedEnquiryDetails({});
    setSelectedEnquiryId(null);
    setMandatoryFieldsError(false); // Optional: Clears error messages if any
  };

  // Handle input change
  // const handleInputChange = (event) => {
  //   setSelectedEnquiryDetails({
  //     ...selectedEnquiryDetails,
  //     [event.target.name]: event.target.value
  //   });
  // };

  // Handle save button click
  // Handle input change
  // Handle input change
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "dob") {
      const currentDate = new Date();
      const selectedDate = new Date(value);
      const ageDiff = currentDate.getFullYear() - selectedDate.getFullYear();
      const isBeforeBirthday =
        currentDate.getMonth() < selectedDate.getMonth() ||
        (currentDate.getMonth() === selectedDate.getMonth() &&
          currentDate.getDate() < selectedDate.getDate());
      const age = isBeforeBirthday ? ageDiff - 1 : ageDiff;

      setSelectedEnquiryDetails({
        ...selectedEnquiryDetails,
        [name]: value,
        age: age,
      });
    } else {
      setSelectedEnquiryDetails({
        ...selectedEnquiryDetails,
        [name]: value,
      });
    }

    // Update registrationData
    setRegistrationData({
      ...registrationData,
      [name]: value,
    });
  };

// Add this constant at the top of the component, after the imports or state declarations
const notificationUrl = "https://wsms.aidigitalsec.com/api/Notifications/PostAssignmentNotification";

// Updated handleSave function
const handleSave = async () => {

  if (!validateForm()) {
    setShowMissingFieldsModal(true);
    setMandatoryFieldsError(true);
    return;
  }

  try {
    setLoadingBarProgress(30);
    const url = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const userId = parseInt(sessionStorage.getItem("userId")) || 0;
    const clientName = sessionStorage.getItem("clientName") || "";
    const apiUrl = `${url}/Registration`;

    const dobParts = selectedEnquiryDetails?.dob.split("-");
    const formattedDOB = dobParts
      ? `${dobParts[2]}/${dobParts[1]}/${dobParts[0]}`
      : "";

     // Format registrationDate
  const regDateParts = registrationDate.split("-");
  const formattedRegDate = regDateParts ? `${regDateParts[2]}/${regDateParts[1]}/${regDateParts[0]}` : "";

    const payload = {
      registrationNo: "New",
      dated: formattedRegDate, 
      enquiryStatus: 0,
      enquiryID: selectedEnquiryId,
      prostetusNo: "string",
      regFees: 0,
      classID: selectedEnquiryDetails?.classId || 0,
      name: registrationData.studentName || "",
      fatherName: registrationData.parentAndGurdian || "",
      dob: formattedDOB || "",
      age: selectedEnquiryDetails?.age || 0,
      gender: selectedEnquiryDetails?.gender || 0,
      nationality: selectedEnquiryDetails?.nationality || "",
      pinCode: selectedEnquiryDetails?.pinCode || "",
      alternateNo: selectedEnquiryDetails?.alternateMobile || "",
      mobileNo: registrationData.contactNo || "",
      email: registrationData.emailId || "", // Email can be empty
      address: selectedEnquiryDetails?.address || "",
      motherName: selectedEnquiryDetails?.motherName || "",
      grandFather: selectedEnquiryDetails?.grandFatherName || "",
      adharNo: selectedEnquiryDetails?.aadharNo || "000000000000",
      countryId: selectedEnquiryDetails?.country || 0,
      stateId: selectedEnquiryDetails?.state || 0,
      cityID: selectedEnquiryDetails?.city || 0,
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Error saving registration: ${response.status}`);
    } else {
      // Send notification for the successfully added registration
      const message = `${clientName} added registration for ${registrationData.studentName}`;
      const notifBody = {
        userId,
        message,
        name: clientName
      };

      await fetch(notificationUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(notifBody),
      }).catch((err) => {
        console.error("Notification API Error:", err);
        // Optionally handle notification failure without blocking the success message
      });

      setShowSuccessModal(true);
      setLoadingBarProgress(100);

      // Clear the fields after successful save
      setRegistrationData({
        studentName: "",
        dob: "",
        contactNo: "",
        parentAndGurdian: "",
        emailId: "",
      });
      setSelectedEnquiryDetails({});
      setSelectedEnquiryId(null);
      setMandatoryFieldsError(false); // Clear mandatory fields error
    }
  } catch (error) {
    setLoadingBarProgress(0);
    // alert("Failed to save data");
    setSnackbarMessage("Failed to save data");
    setOpenSnackbar(true);
    setSnackbarSeverity("error")
  }
};


  return (
    <>
      <LoadingBar
        progress={loadingBarProgress}
        color="rgb(152, 106, 182)"
        height={5}
      />
      <Container>
        <Box
          sx={{
            backgroundColor: '#0B1F40', // dark navy blue
            padding: '12px 24px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            margin: '2px auto',
            width: "100%",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', textAlign: 'center', fontWeight: 'bold', flexGrow: 1 }}>
            Add Registration
          </Typography>

          {/* ── Info Button ── */}
          <IconButton
            onClick={() => setInfoOpen(true)}
            title="Form Information"
            style={{
              backgroundColor: "rgba(255,255,255,0.15)",
              border: "2px solid rgba(255,255,255,0.6)",
              borderRadius: "50%",
              padding: "6px",
              color: "#fff",
            }}
          >
            <InfoIcon style={{ fontSize: 26 }} />
          </IconButton>
        </Box>

        {/* ── Info Dialog ── */}
        <Dialog
          open={infoOpen}
          onClose={() => setInfoOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{ style: { borderRadius: 16, padding: 0 } }}
        >
          <DialogTitle
            style={{
              backgroundColor: "#0B1F40",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "16px 24px",
            }}
          >
            <Box display="flex" alignItems="center">
              <InfoIcon style={{ marginRight: 8 }} />
              <Typography variant="h6" style={{ fontWeight: "bold" }}>
                Add Registration — Form Guide
              </Typography>
            </Box>
           
          </DialogTitle>

          <DialogContent dividers style={{ backgroundColor: "#f9f9f9", padding: "24px" }}>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 20 }}>
              This form is used to register a new student. You can either link an existing enquiry using the search icon or fill in the details manually. Below is a section-by-section guide.
            </Typography>

            {registrationInfoSections.map((section, index) => (
              <Box
                key={index}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: 12,
                  padding: "18px 20px",
                  marginBottom: 16,
                  borderLeft: `5px solid ${section.color}`,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                }}
              >
                <Typography
                  variant="h6"
                  style={{ fontWeight: "bold", color: section.color, marginBottom: 6 }}
                >
                  {section.title}
                </Typography>

                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 10 }}>
                  {section.description}
                </Typography>

                <Divider style={{ marginBottom: 10 }} />

                {/* Fields */}
                <Typography variant="caption" style={{ fontWeight: "bold", color: "#555", display: "block", marginBottom: 6 }}>
                  📝 FIELDS
                </Typography>
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {section.fields.map((field, i) => (
                    <Chip
                      key={i}
                      label={field}
                      size="small"
                      variant={section.title === "Mandatory Fields" ? "filled" : "outlined"}
                      style={{
                        borderColor: section.color,
                        color: section.title === "Mandatory Fields" ? "#fff" : section.color,
                        backgroundColor: section.title === "Mandatory Fields" ? section.color : "transparent",
                        fontWeight: section.title === "Mandatory Fields" ? "bold" : 400,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            ))}
          </DialogContent>

          <DialogActions style={{ padding: "12px 24px", backgroundColor: "#f9f9f9" }}>
            <Button
              onClick={() => setInfoOpen(false)}
              variant="contained"
              style={{ backgroundColor: "#0B1F40", color: "#fff", borderRadius: 20, paddingInline: 28 }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Registration Details */}
        <form>
          <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Reg No."
                  variant="outlined"
                  placeholder="New"
                  margin="normal"
                // Adding readOnly attribute
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Enquiry No."
                  variant="outlined"
                  placeholder="Enter Enquiry No."
                  margin="normal"
                  value={selectedEnquiryDetails?.enquiryCode || ""}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleSearchClick}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Date"
                  type="date"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  value={registrationDate}
                  onChange={(e) => setRegistrationDate(e.target.value)}
                />

              </Grid>
              <Grid item xs={12}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Without Enquiry</FormLabel>
                  <RadioGroup
                    row
                    aria-label="enquiry"
                    name="enquiry"
                    value={selectedEnquiryDetails?.enquiryCode ? "no" : "yes"}
                    onChange={(event) => {
                      handleInputChange(event);
                      setSelectedEnquiryDetails({
                        ...selectedEnquiryDetails,
                        enquiryCode:
                          event.target.value === "no"
                            ? selectedEnquiryDetails.enquiryCode
                            : "",
                      });
                    }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            {/* Class Details */}
            <Typography
              variant="h6"
              style={{ marginTop: "20px", marginBottom: "20px" }}
            >
              Class Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="class-label">Class *</InputLabel>
                  <Select
                    labelId="class-label"
                    id="class"
                    label="Class *"
                    value={selectedEnquiryDetails?.classId || ""}
                    required
                    onChange={handleInputChange}
                    name="classId"
                  >
                    {ddlClass.map((item) => (
                      <MenuItem key={item.classId} value={item.classId}>
                        {item.className}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="DOB *"
                  type="date"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={selectedEnquiryDetails?.dob || ""}
                  onChange={handleInputChange}
                  name="dob"
                />
                {mandatoryFieldsError && !registrationData.dob && (
                  <FormHelperText error>
                    Please select date of birth
                  </FormHelperText>
                )}
              </Grid>
            </Grid>

            {/* Personal Details */}
            <Typography
              variant="h6"
              style={{ marginTop: "20px", marginBottom: "20px" }}
            >
              Personal Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Student Name *"
                  variant="outlined"
                  value={registrationData?.studentName || ""}
                  required
                  onChange={handleInputChange}
                  name="studentName"
                />
                {mandatoryFieldsError && !registrationData.studentName && (
                  <FormHelperText error>Please enter student name</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Father's Name *"
                  variant="outlined"
                  value={registrationData?.parentAndGurdian || ""} // Use parentAndGurdian
                  required
                  onChange={handleInputChange}
                  name="parentAndGurdian" // Use parentAndGurdian
                />
                {mandatoryFieldsError && !registrationData.parentAndGurdian && (
                  <FormHelperText error>
                    Please enter father's name
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Mother's Name *"
                  variant="outlined"
                  value={selectedEnquiryDetails?.motherName || ""}
                  required
                  onChange={handleInputChange}
                  name="motherName"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Grand Father's Name *"
                  variant="outlined"
                  value={selectedEnquiryDetails?.grandFatherName || ""}
                  required
                  onChange={handleInputChange}
                  name="grandFatherName"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Prospectus"
                  variant="outlined"
                  value={selectedEnquiryDetails?.prospectus || ""}
                  onChange={handleInputChange}
                  name="prospectus"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Aadhar No."
                  variant="outlined"
                  value={selectedEnquiryDetails?.aadharNo || ""}
                  onChange={handleInputChange}
                  name="aadharNo"
                  inputProps={{ maxLength: "12" }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="gender-label">Gender *</InputLabel>
                  <Select
                    labelId="gender-label"
                    id="gender"
                    label="Gender *"
                    required
                    value={selectedEnquiryDetails?.gender || ""}
                    onChange={handleInputChange}
                    name="gender"
                  >
                    {gender.map((item) => (
                      <MenuItem key={item.genderId} value={item.genderId}>
                        {item.gender}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Nationality"
                  variant="outlined"
                  value={selectedEnquiryDetails?.nationality || ""}
                  onChange={handleInputChange}
                  name="nationality"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Mobile No. *"
                  variant="outlined"
                  value={registrationData?.contactNo || ""}
                  required
                  onChange={handleInputChange}
                  name="contactNo"
                  inputProps={{ maxLength: "10" }}
                />
                {mandatoryFieldsError && !registrationData.contactNo && (
                  <FormHelperText error>
                    Please enter mobile number
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Alternate Mobile No. *"
                  variant="outlined"
                  value={selectedEnquiryDetails?.alternateMobile || ""}
                  required
                  onChange={handleInputChange}
                  name="alternateMobile"
                  inputProps={{ maxLength: "10" }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Email-Id"
                  variant="outlined"
                  value={registrationData?.emailId || ""}
                  onChange={handleInputChange}
                  name="emailId"
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Address"
                  variant="outlined"
                  value={selectedEnquiryDetails?.address || ""}
                  onChange={handleInputChange}
                  name="address"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Pin Code"
                  variant="outlined"
                  value={selectedEnquiryDetails?.pinCode || ""}
                  onChange={handleInputChange}
                  name="pinCode"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="country-label">Country *</InputLabel>
                  <Select
                    labelId="country-label"
                    id="country"
                    label="Country *"
                    required
                    value={selectedEnquiryDetails?.country || ""}
                    onChange={(event) => {
                      handleInputChange(event);
                      fetchState(event.target.value); // Pass the selected countryId to fetchState function
                    }}
                    name="country"
                  >
                    {country.map((item) => (
                      <MenuItem key={item.countryId} value={item.countryId}>
                        {item.countryName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="state-label">State *</InputLabel>
                  <Select
                    labelId="state-label"
                    id="state"
                    label="State *"
                    required
                    value={selectedEnquiryDetails?.state || ""}
                    onChange={(event) => {
                      handleInputChange(event);
                      fetchCity(event.target.value);
                    }}
                    name="state"
                  >
                    {state.map((item) => (
                      <MenuItem key={item.stateId} value={item.stateId}>
                        {item.stateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="city-label">City *</InputLabel>
                  <Select
                    labelId="city-label"
                    id="city"
                    label="City *"
                    required
                    value={selectedEnquiryDetails?.city || ""}
                    onChange={handleInputChange}
                    name="city"
                  >
                    {city.map((item) => (
                      <MenuItem key={item.cityId} value={item.cityId}>
                        {item.cityName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/* Buttons */}
            <div style={{ marginTop: "20px", textAlign: "end" }}>
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginRight: "10px", width: "100px",
                  height: "50px",
                  padding: "10px 0",
                  fontWeight: 'bold'
                }}
                onClick={handleSave}
              >
                SAVE
              </Button>
              <Button variant="contained" color="error" onClick={handleReset} style={{
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}>
                RESET
              </Button>
            </div>
          </Paper>
        </form>
        {/* Modal */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="enquiry-list-modal"
          aria-describedby="enquiry-list-modal-description"
        >
          <Container
            sx={{
              marginTop: "20px",
              width: "80vw",
              height: "80vh",
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
            <Typography variant="h5" align="center" gutterBottom>
              Enquiry List
            </Typography>
            <TableContainer sx={{ maxHeight: "60vh" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Enquiry ID</TableCell>
                    <TableCell>Student Name</TableCell>
                    <TableCell>Enquiry Code</TableCell>
                    <TableCell>Parent/Guardian</TableCell>
                    <TableCell>Contact No.</TableCell>
                    <TableCell>Enquiry Date</TableCell>
                    <TableCell>Class Name</TableCell>
                    <TableCell>Select</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {enquiryData.map((enquiry) => (
                    <TableRow key={enquiry.enquiryId}>
                      <TableCell>{enquiry.enquiryId}</TableCell>
                      <TableCell>{enquiry.studentName}</TableCell>
                      <TableCell>{enquiry.enquiryCode}</TableCell>
                      <TableCell>{enquiry.parentAndGurdian}</TableCell>
                      <TableCell>{enquiry.contactNo}</TableCell>
                      <TableCell>{enquiry.enquiryDate}</TableCell>
                      <TableCell>{enquiry.className}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            setSelectedEnquiryId(enquiry.enquiryId);
                            handleSelect(enquiry.enquiryId);
                          }}
                        >
                          Select
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Container>
        </Modal>

        <Modal
          open={showMissingFieldsModal}
          onClose={() => setShowMissingFieldsModal(false)}
          aria-labelledby="missing-fields-modal-title"
          aria-describedby="missing-fields-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
              <Typography id="missing-fields-modal-title" variant="h6" sx={{ color: '#fff' }}>
                Missing Fields
              </Typography>
            </Box>
            <Box sx={{ padding: '20px' }}>
              <Typography id="missing-fields-modal-description" sx={{ mb: 2 }}>
                The following fields are required:
              </Typography>
              <ul>
                {missingFields.map((field, index) => (
                  <li key={index}>- {field}</li>
                ))}
              </ul>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                  onClick={() => setShowMissingFieldsModal(false)}
                  variant="contained"
                  color="primary"
                >
                  OK
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
          aria-labelledby="success-modal-title"
          aria-describedby="success-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
              <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
                Registration Added ✅
              </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ padding: '20px' }}>
              <Typography id="success-modal-description" sx={{ mb: 2 }}>
                Registration has been added successfully.
              </Typography>

              {/* Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                  onClick={() => {
                    setShowSuccessModal(false);
                    navigate(-1); // go back after closing modal
                  }}
                  variant="contained"
                  color="primary"
                >
                  OK
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

      </Container>
    </>
  );
}

export default AddRegistration;